import React, { useState } from 'react'
import { Table } from 'Components/Table'
import { Td } from 'Components/Table/Td'
import { Th } from 'Components/Table/Th'
import { Tr } from 'Components/Table/Tr'

const sortTableColumns = (items, columnName, isReverse) => {
  const sortedItems = items.sort((a, b) =>
    a[columnName] > b[columnName] ? 1 : b[columnName] > a[columnName] ? -1 : 0,
  )

  if (isReverse) {
    return sortedItems.reverse()
  } else {
    return sortedItems
  }
}

const SummaryView = ({ data, formatCurrency }) => {
  const { cities, bonusResults } = data
  const { bonusAllowance, bonusPaidSoFar, bonusUsage, baResults } = bonusResults
  const bonusRemainder = parseFloat(bonusAllowance - bonusPaidSoFar).toFixed(2)
  const [state, setState] = useState({
    columnName: 'missions',
    isReverse: false,
  })

  const changeSort = event => {
    const columnName = event.target.id
    if (state.columnName == columnName) {
      setState(state => ({ ...state, isReverse: !state.isReverse }))
    } else {
      setState(state => ({
        ...state,
        columnName: columnName,
        isReverse: !state.isReverse,
      }))
    }
  }

  const tableRows = cities.map(city => {
    const { name, id } = city
    return baResults
      .filter(ba => ba.cityId === id)
      .reduce(
        (prev, cur) => {
          prev.missionsCount += cur.missionsCount
          prev.conversionsCount += cur.conversionsCount
            ? cur.conversionsCount
            : 0
          prev.totalBonusPaid += cur.totalBonusPaid
          return prev
        },
        {
          name,
          missionsCount: 0,
          conversionsCount: 0,
          totalBonusPaid: 0,
        },
      )
  })

  const sortRows = sortTableColumns(
    tableRows,
    state.columnName,
    state.isReverse,
  )

  const totalsRow = sortRows.reduce(
    (prev, cur) => {
      prev.missionsCount += cur.missionsCount
      prev.conversionsCount += cur.conversionsCount ? cur.conversionsCount : 0
      prev.totalBonusPaid += cur.totalBonusPaid
      return prev
    },
    {
      name: 'Totals',
      missionsCount: 0,
      conversionsCount: 0,
      totalBonusPaid: 0,
      bonusAllowance,
      bonusRemainder,
      bonusUsage,
    },
  )

  return (
    <Table>
      <thead>
        <Tr>
          <Th />
          <Th className="sortable" id={'missionsCount'} onClick={changeSort}>
            Missions
          </Th>
          <Th className="sortable" id={'conversionsCount'} onClick={changeSort}>
            Conversions
          </Th>
          <Th className="sortable" id={'totalBonusPaid'} onClick={changeSort}>
            Bonus Paid
          </Th>
          <Th id={'bonusAllowance'}>Bonus Allowance</Th>
          <Th id={'bonusRemainder'}>Bonus Remainder</Th>
          <Th id={'bonusUsage'}>Bonus usage</Th>
        </Tr>
      </thead>
      <tbody>
        <RenderRow
          row={totalsRow}
          formatCurrency={formatCurrency}
          isBold={true}
        />
        {sortRows.map((row, key) => (
          <RenderRow key={key} row={row} formatCurrency={formatCurrency} />
        ))}
      </tbody>
    </Table>
  )
}

const RenderRow = ({ row, formatCurrency, isBold = false }) => {
  const {
    name,
    missionsCount,
    conversionsCount,
    totalBonusPaid,
    bonusAllowance,
    bonusRemainder,
    bonusUsage,
  } = row
  return (
    <Tr>
      <RenderColumn isBold={isBold}>{name}</RenderColumn>
      <RenderColumn isBold={isBold}>{missionsCount}</RenderColumn>
      <RenderColumn isBold={isBold}>
        {conversionsCount === null ? 'Not updated' : conversionsCount}
      </RenderColumn>
      <RenderColumn isBold={isBold}>
        {formatCurrency(parseFloat(totalBonusPaid).toFixed(2))}
      </RenderColumn>
      <RenderColumn isBold={isBold}>
        {bonusAllowance &&
          formatCurrency(parseFloat(bonusAllowance).toFixed(2))}
      </RenderColumn>
      <RenderColumn isBold={isBold}>
        {bonusRemainder &&
          formatCurrency(parseFloat(bonusRemainder).toFixed(2))}
      </RenderColumn>
      <RenderColumn isBold={isBold}>
        {bonusUsage && parseFloat(bonusUsage).toFixed(2) + '%'}
      </RenderColumn>
    </Tr>
  )
}

const RenderColumn = ({ children, isBold }) => {
  return isBold ? (
    <Td>
      <b>{children}</b>
    </Td>
  ) : (
    <Td>{children}</Td>
  )
}
export default SummaryView
